var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reclamations app__page"},[_c('div',{staticClass:"reclamations__iframe-wrapper"},[_c('iframe',{attrs:{"id":"imagepgframe","name":"imagepgframe","frameborder":"0","scrolling":"auto","src":"https://nspharm.com/r/"}})])])
}]

export { render, staticRenderFns }